import { gql } from "@apollo/client";

export default gql`
  query GetMergeDevIntegrations($organizationId: Int!) {
    mergeDevIntegrations(organizationId: $organizationId) {
      id
      category
      integrationName
      createdAt
      updatedAt
    }
  }
`;
